import { useTranslation } from 'react-i18next'

import CircleInfo from '@/presentation/assets/svg/CircleCheck'
import StarIcon from '@/presentation/assets/svg/Star.svg'
import Button from '@/presentation/components/Button'
import { ROUTES } from '@/services/constants/routes'
import useNavigateWithOrderCode from '@/services/hooks/useNavigateWithOrderCode'

type SuccessGoogleModalProps = {
  googleReviewUrl: string
}

const SuccessGoogleModal: React.FC<SuccessGoogleModalProps> = ({
  googleReviewUrl
}: SuccessGoogleModalProps) => {
  const { t } = useTranslation()
  const navigate = useNavigateWithOrderCode()

  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer')
    setTimeout(() => {
      navigate(ROUTES.MAIN)
    }, 2000)
  }

  const handleSkip = () => {
    navigate(ROUTES.MAIN)
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#70707059] px-4">
      <div className="flex flex-col items-center gap-4 rounded-lg bg-white p-8 shadow-md">
        <p className="flex items-center justify-center gap-2 text-lg font-bold text-[#4F6066]">
          <CircleInfo /> {t('MODAL_RATING_GOOGLE_TITLE')}
        </p>

        <p className="text-lg font-bold text-[#4F6066]">
          {t('MODAL_RATING_GOOGLE_SUBTITLE')}
        </p>

        <p className="text-justify text-lg text-[#4F6066]">
          {t('MODAL_RATING_GOOGLE_MESSAGE_1')}
          <br />
          {t('MODAL_RATING_GOOGLE_MESSAGE_2')}
          <br />
          {t('MODAL_RATING_GOOGLE_MESSAGE_3')}
        </p>

        <div className="flex w-full flex-col gap-2">
          <Button
            className="mx-auto my-2 flex w-full max-w-[210px] justify-between"
            onClick={() => handleClick(googleReviewUrl)}
          >
            {t('MODAL_RATING_GOOGLE_BUTTON')}{' '}
            <img src={StarIcon} className="size-6" />
          </Button>

          <button
            className="text-sm text-[#4F6066] underline transition-colors hover:text-[#2a3a3f]"
            onClick={handleSkip}
          >
            {t('MODAL_RATING_GOOGLE_SKIP')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SuccessGoogleModal
